<div class="singleselection-dropDown-div">
    <p-dropdown #dropdownList appendTo="body" [placeholder]="placeholder" [options]="options"
        [optionLabel]="optionLabel" [optionValue]="optionValue" [filter]="filterable" [disabled]="editable == false"
        [(ngModel)]="selectedValue" (onChange)="onChange($event)" (onShow)="onShow($event)"
        styleClass="ddlSelection">
    </p-dropdown>
</div>